module.exports = __webpack_public_path__ + "img/categorie-nos-points-de-vente-medium.f50d383f.jpg";